import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withMsal } from '@azure/msal-react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import './styles.scss';
import Notification from './../../components/Notification/';
import * as actions from './../../data/login/actions';
import * as settingactions from './../../data/settings/actions';
import { JWTOKEN, MOCK_MODE } from '../../data/constants';
import Logo from './../../components/Logo/';
import { home } from '../../settings/settings';
import { useLanguage } from '../../context/LanguageContext';

const LoginButton = withStyles({
  root: {
    boxShadow: 'none',
    textTransform: 'none',
    padding: '0px 0px'
  },
})(Button);

class LoginMsal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: 0,
      pass: '',
      showSnackBar: false
    };
  }
  componentDidUpdate() {
    if (this.props.error.loginError === true) {
      this.openSnackBar();
    }
  }
  openSnackBar = () => {
    //this.setState({ showSnackBar: true });
  };
  closeSnackBar = () => {
    //this.setState({ showSnackBar: false, error: { loginError: false, message: '' } });
  };
  handleLogin = () => {
    const { fetchLoginMsal } = this.props;
    fetchLoginMsal();
  };

  render() {
    const loginLabels = this.props.labels?.login || {};
    return (
      <main className="Login">
        <section className="Login-Wrapper">
          <Logo />
          <article>
            <div className="Login-Wrapper-FloatingLabel">
              {loginLabels.FLOATING_LABEL}
            </div>
            <div className="Login-Wrapper-Button-Container">
              <LoginButton onClick={this.handleLogin}>
                <div className="Login-Wrapper-Button">
                  <i
                    className="ion ion-android-arrow-forward"
                    aria-hidden="true"
                    style={{ color: '#fff' }}
                  />
                </div>
              </LoginButton>
            </div>
          </article>
        </section>
        {(process.env.SERVERLESS || MOCK_MODE) && (
          <p style={{ color: 'white' }}>MOCK SERVER ON</p>
        )}

        <footer className="Login-Footer">
          <div>
            <figure>
              <img src="assets/img/IBS_Software_logo.png" alt="" />
            </figure>
          </div>
          <div className="Login-Footer-Disclaimer">
            <span>{loginLabels.DISCLAIMER_ITALIC}</span>
            {loginLabels.DISCLAIMER_REGULAR}
          </div>
        </footer>
          {/*<Notification*/}
          {/*  open={this.state.showSnackBar}*/}
          {/*  message={this.props.error.message}*/}
          {/*  closeStatusDisplay={this.closeSnackBar}*/}
          {/*/>*/}
      </main>
    );
  }
}

LoginMsal.defaultProps = {
  fetchLoginMsal: function fetchLoginMsal() {},
  location: {},
  redirect: function redirect() {},
  error: {},
  getLanguage: () => {}
};

LoginMsal.propTypes = {
  fetchLoginMsal: PropTypes.func,
  location: PropTypes.object,
  redirect: PropTypes.func,
  getLanguage: PropTypes.func,
  error: PropTypes.shape({
    loginError: PropTypes.bool,
    message: PropTypes.string
  })
};

const mapStateToProps = state => ({ ...state.login });

const mapDispatchToProps = dispatch => ({
  fetchLoginMsal: msalContext => dispatch(actions.default.fetchLoginMsal(msalContext)),
  redirect: path => dispatch(actions.default.redirect(path)),
  getLanguage: staffId => dispatch(settingactions.getLanguage(staffId))
});

const ConnectedLoginMsal = withMsal(connect(mapStateToProps, mapDispatchToProps)(LoginMsal));

function LoginMsalWrapper(props) {
  const { labels } = useLanguage();
  return <ConnectedLoginMsal {...props} labels={labels} />;
}

export default LoginMsalWrapper;
